export default {
      id: "reefer-wizard-usage",
      viewBox: "0 0 33 25",
      url: __webpack_public_path__ + "img/icons.svg#reefer-wizard",
      toString: function () {
        return this.url;
      }
    }